var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"specta-container"},[_c('div',{staticClass:"loader"},[_c('Loading'),_c('p',[_vm._v("Please hold on while we confirm payment.")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }